import type { Role } from '../../api/types';

type Maybe<T> = T | null | undefined;

export function canManageGames(role: Maybe<Role>): boolean {
  return role === 'organizer' || role === 'admin';
}
